import { ColorTheme, colorThemeVariants } from '@theme/partials/palette.css';
import { ColorTheme as ColorThemeField } from '_generated/types';

export const parseColorTheme = (data: Maybe<ColorThemeField>) => {
  const label = data?.label;

  return label && label in colorThemeVariants ? (label as ColorTheme) : null;
};
